import capitializeFirstChar from './capitializeFirstChar'

export default (str = '') =>
	str
		.split('-')
		.map(val => capitializeFirstChar(val))
		.join(' ')
